export default __webpack_public_path__ + "static/media/hublot-watch-2018.a639dff6.webp";